import VisaModal from '@/models/Visa';

const GET_VISA_AUDIT_MATERIAL_INFO = 'GET_VISA_AUDIT_MATERIAL_INFO';
const UPLOAD_VISA_AUDIT_MATERIAL = 'UPLOAD_VISA_AUDIT_MATERIAL';
const CONFIRM_VISA_AUDIT = 'CONFIRM_VISA_AUDIT';

/**
 * 获取签证订单预审材料
 */
async function getVisaAuditMaterialInfo(tradeCode) {
  const payload = await new VisaModal().auditMaterialInfo(tradeCode);
  return {
    type: GET_VISA_AUDIT_MATERIAL_INFO,
    payload
  }
}

/**
 * 更新签证预审材料
 */
async function uploadVisaAuditMaterial(params) {
  const payload = await new VisaModal().uploadMaterial(params);
  return {
    type: UPLOAD_VISA_AUDIT_MATERIAL,
    payload
  }
}

/**
 * 提交签证预审
 */
async function confirmVisaAudit(tradeCode) {
  const payload = await new VisaModal().confirmAudit(tradeCode);
  return {
    type: CONFIRM_VISA_AUDIT,
    payload
  }
}

const ACTION_TYPES = {
  GET_VISA_AUDIT_MATERIAL_INFO,
  UPLOAD_VISA_AUDIT_MATERIAL,
  CONFIRM_VISA_AUDIT,
};

const ACTION = {
  getVisaAuditMaterialInfo,
  uploadVisaAuditMaterial,
  confirmVisaAudit,
};

const VisaAuditMaterialInfo = {
  ACTION_TYPES,
  ACTION
}

export default VisaAuditMaterialInfo;